module.exports = __webpack_public_path__ + "static/img/award1.34d64ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/index/award1.png
// module id = Imvf
// module chunks = 7